import styles from './Account.module.css';
import Icon from './Icon';

// Single source of truth for the tab list - the page maps over this too.
export const ACCOUNT_TABS = [
  { key: 'overview',     label: 'Overview',       icon: 'grid' },
  { key: 'billing',      label: 'Billing',        icon: 'creditCard' },
  { key: 'subscription', label: 'Subscription',   icon: 'package' },
  { key: 'usage',        label: 'Usage',          icon: 'activity' },
  { key: 'invoices',     label: 'Invoices',       icon: 'fileText' },
  { key: 'security',     label: 'Security',        icon: 'shield' },
  { key: 'integrations', label: 'Integrations',    icon: 'plug'   },
  { key: 'memory',       label: 'Memory',          icon: 'zap'    },
];

function initials(name, email) {
  if (name) {
    const parts = name.trim().split(/\s+/);
    return (parts[0][0] + (parts[1]?.[0] || '')).toUpperCase();
  }
  return (email?.[0] || '?').toUpperCase();
}

export default function AccountSidebar({ active, onSelect, identity }) {
  return (
    <nav className={styles.sidebar} aria-label="Account sections">
      {identity && (identity.name || identity.email) && (
        <div className={styles.sidebarUser}>
          <div className={styles.avatar} aria-hidden="true">
            {initials(identity.name, identity.email)}
          </div>
          <div className={styles.sidebarUserInfo}>
            <div className={styles.sidebarUserName}>{identity.name || 'Your account'}</div>
            {identity.email && <div className={styles.sidebarUserEmail}>{identity.email}</div>}
          </div>
        </div>
      )}

      <div className={styles.sidebarHeading}>Account</div>
      {ACCOUNT_TABS.map((tab) => (
        <button
          key={tab.key}
          className={`${styles.navItem} ${active === tab.key ? styles.navItemActive : ''}`}
          onClick={() => onSelect(tab.key)}
          aria-current={active === tab.key ? 'page' : undefined}
        >
          <span className={styles.navIcon}><Icon name={tab.icon} size={16} /></span>
          <span className={styles.navLabel}>{tab.label}</span>
        </button>
      ))}
    </nav>
  );
}
